const principles = [
  {
    number: '01',
    title: 'Clean architecture as foundation',
    description:
      'Every system we build starts with a clear architectural blueprint. Modularity, separation of concerns, and long-term maintainability are not afterthoughts — they are the first decisions we make.',
  },
  {
    number: '02',
    title: 'Performance at every layer',
    description:
      'Optimization is not a final step. We embed performance thinking throughout the entire development lifecycle, from initial design through deployment and ongoing refinement.',
  },
  {
    number: '03',
    title: 'User-centered design rigor',
    description:
      'Technical excellence means nothing if the result is unusable. We ground every decision in how real people think, work, and interact — then build systems that feel inevitable.',
  },
  {
    number: '04',
    title: 'Continuous workflow evolution',
    description:
      'We actively explore new engineering practices, refine internal standards, and adopt up-to-date methodologies. Our processes are living systems that improve with every iteration.',
  },
];

export default function ApproachSection() {
  return (
    <section className="w-full bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-24 md:py-36">
        {/* Section header */}
        <div className="mb-20 md:mb-28">
          <span className="inline-block text-xs font-label text-foreground-400 tracking-widest uppercase mb-6">
            Our approach
          </span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-[1.1] tracking-tight max-w-3xl">
            Building reliable systems through disciplined engineering
          </h2>
        </div>

        {/* Numbered principles */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
          {principles.map((item, i) => (
            <div
              key={i}
              className={`group py-12 md:py-16 px-0 border-t border-foreground-50/8 ${
                i % 2 === 0 ? 'lg:pr-16' : 'lg:pl-16'
              } ${i >= principles.length - 2 ? 'border-b border-foreground-50/8' : ''}`}
            >
              {/* Number */}
              <span className="block font-label text-5xl md:text-7xl font-medium text-foreground-50/8 tracking-tighter leading-none mb-6">
                {item.number}
              </span>

              {/* Title */}
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-50 leading-tight mb-4">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-md">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}